import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useScene } from "./SceneController";

const COUNT = 25;

export default function DocumentCloud() {
    const group = useRef();
    const { sceneState } = useScene();
    const documents = useMemo(() => {
        return Array.from({ length: COUNT }, (_, i) => ({
            id: i,
            angle: Math.random() * Math.PI * 2,
            radius: 2 + Math.random() * 2,
            height: (Math.random() - 0.5) * 3,
            speed: 0.3 + Math.random() * 0.5,
        }));
    }, []);

    useFrame(( state ) => {
        const t = state.clock.elapsedTime;

        if (!group.current) return;

        group.current.children.forEach((mesh, i) => {
            const d = documents[i];

            // CHAOTIC DOCUMENT FLOW
            if (sceneState.section === "hero" || sceneState.section === "problem") {
                mesh.position.x = Math.cos(t * d.speed + d.angle) * d.radius;
                mesh.position.z = Math.sin(t * d.speed + d.angle) * d.radius;
                mesh.position.y = d.height + Math.sin(t * 2 + d.angle) * 0.3;
                mesh.rotation.x += 0.01;
                mesh.rotation.y += 0.02;
            }

            // ORGANIZED WORKFLOW
            else {
                const column = i % 5;
                const row = Math.floor(i / 5);
                mesh.position.lerp(
                    new THREE.Vector3(column * 0.5 - 1, row * 0.35 - 1, 0),
                    0.03,
                );

                mesh.rotation.x *= 0.95;
                mesh.rotation.y *= 0.95;
            }
        });
    });

    return (
        <group ref={group}>
            {documents.map((doc) => (
                <mesh key={doc.id}>
                    <boxGeometry args={[0.25, 0.35, 0.02]} />

                    <meshStandardMaterial
                        color="#ffffff"
                        emissive="#38bdf8"
                        emissiveIntensity={0.4}
                        roughness={0.2}
                    />
                </mesh>
            ))}
        </group>
    );
}
